import {createApp} from "vue";
import SendMessageForm from "./components/SendMessageForm.vue";
import ApplicationForm from "./components/ApplicationForm.vue";
import ApplyWithCV from "./components/ApplyWithCV.vue";
import Dropzone from "./components/Dropzone.vue";
import Provider from "./provider.ts";

createApp({})
    .provide('Provider', new Provider())
    .component('ApplyWithCV', ApplyWithCV)
    .component('ApplicationForm', ApplicationForm)
    .component('Dropzone', Dropzone)
    .mount('.job-detail-module');

createApp({})
    .component('SendMessageForm', SendMessageForm)
    .mount('#msg-modal');


